/*
    Builds API resource path for fetch method that will request units list.
 */
export default function getResourcePath(): string {
    const { REACT_APP_API_PATH, REACT_APP_TOUR_ID_PARAM_KEY } = process.env;

    if (!REACT_APP_API_PATH || !REACT_APP_TOUR_ID_PARAM_KEY) {
        console.error('API configuration has been not provided.');
    }

    const queryParams = new URLSearchParams(window.location.search);
    const tourId = queryParams.get(REACT_APP_TOUR_ID_PARAM_KEY as string);
    return tourId ? `${REACT_APP_API_PATH}/${tourId}` : '';
}
